import React from 'react';
import {ListScreenContainer} from '../ListScreen';

export function MobileListScreenContainer() {
  return <ListScreenContainer />;
}
